import {
  ActuatorModalityType,
  ConfigurationType,
  RoomObjectDTO,
  Slot,
  SlotStatus,
  ThermoActuatorType,
  RoomObjectType,
  ComponentType,
  DeviceDTO,
} from '@/../client-generator/generated-clients/plants';
import i18n from '../../translations/i18n';
import {
  SlotRuleServiceType,
  WorkflowCallbackData,
  WorkflowCallbackFunction,
} from './slots-assign-rules-interfaces';
import BaseSlotRuleService from './slots-assign-rules-service';

export default class AssignAutomationActuatorSlotRuleService extends BaseSlotRuleService {
  constructor(
    roomObject: RoomObjectDTO,
    workflowCallback: WorkflowCallbackFunction
  ) {
    super(
      roomObject,
      -1,
      ThermoActuatorType.None,
      ActuatorModalityType.None,
      workflowCallback
    );
    this.slotRuleServiceType = SlotRuleServiceType.AUTOMATION_ACTUATOR;

    if (roomObject.type == RoomObjectType.Blind) {
      this._noOfAdjacent = this.FourAdjacent;
    } else {
      this._noOfAdjacent =
        roomObject.type == RoomObjectType.Shutter
          ? this.TwoAdjacent
          : this.OneAdjacent;
    }
  }

  onSlotMessage(device: DeviceDTO, slot: Slot) {
    switch (slot.status) {
      case SlotStatus.Configured:
        {
          if (this.isSlotLinkedWithCurrentRoomObject(slot)) {
            const data: WorkflowCallbackData = {
              warningTitle: `${i18n.global.t(
                'AppResource.UnlinkThe'
              )} ${i18n.global.t('AppResource.Channel')}`,
              warningMessage: `${i18n.global.t(
                'AppResource.UnlinkMessage'
              )} ${i18n.global.t('AppResource.Channel')} ${
                slot.index
              } ${i18n.global.t('AppResource.From')} ${this.roomObject.name}`,
              isConfirmation: true,
              isWarningRequested: true,
              _isUnlinkFlow: true,
            };
            this._workflowCallback(
              data,
              () => this.doYesCommand(data, device, slot),
              () => this.doNoCommand(data, device, slot)
            );
          } else {
            if (
              this.isSlotRoomObjectTypeMatchingAndNotLinked(slot) ||
              this.isSlotLinkedAsPump(slot)
            ) {
              //AS: CurrentStatus does not influence Lights
              this.markOrUnmarkSlot(
                this.roomObject,
                slot,
                device,
                SlotStatus.Configured,
                SlotStatus.MarkedForLinking
              );
              //}
            }
          }
        }
        break;
      case SlotStatus.NotConfigured:
        {
          if (device != null) {
            var tmp = device.slots?.filter((sl) =>
              this.slotHasAdjacentSlots(slot, sl)
            );
            var _adjacentSlotVm =
              tmp && tmp?.length > 0 ? tmp[tmp?.length - 1] : null;

            if (
              device != null &&
              device.componentTypes?.includes(ComponentType.DimmerActuator) &&
              device.canHandleDoubleDimmer &&
              _adjacentSlotVm != null
            ) {
              const data: WorkflowCallbackData = {
                warningTitle: i18n.global.t('AppResource.SingleLoadFlow'),
                warningMessage: i18n.global.t(
                  'AppResource.SingleLoadFlowMessage'
                ),
                isConfirmation: true,
                isWarningRequested: true,
                _isSingleLoadFlow: true,
              };
              this._workflowCallback(
                data,
                () => this.doYesCommand(data, device, slot),
                () => this.doNoCommand(data, device, slot)
              );
            } else {
              if (this.roomObject.devices) {
                for (var _device of this.roomObject.devices) {
                  if (_device.slots) {
                    for (var _slotList of _device.slots) {
                      if (
                        _slotList.status == SlotStatus.MarkedForLinking &&
                        (_slotList.assignedComponentType ==
                          ComponentType.Actuator ||
                          _slotList.assignedComponentType ==
                            ComponentType.BlindActuator ||
                          _slotList.assignedComponentType ==
                            ComponentType.ShutterActuator ||
                          _slotList.assignedComponentType ==
                            ComponentType.DimmerActuator)
                      ) {
                        if (_slotList != slot) {
                          this.markOrUnmarkSlot(
                            this.roomObject,
                            _slotList,
                            _device,
                            SlotStatus.MarkedForLinking,
                            SlotStatus.NotConfigured
                          );
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          this.markOrUnmarkSlot(
            this.roomObject,
            slot,
            device,
            SlotStatus.NotConfigured,
            SlotStatus.MarkedForLinking
          );
        }
        break;
      case SlotStatus.MarkedForLinking:
        {
          //slot.status = SlotStatus.NotConfigured;

          this.markOrUnmarkSlot(
            this.roomObject,
            slot,
            device,
            SlotStatus.MarkedForLinking,
            SlotStatus.NotConfigured
          );
        }
        break;
      case SlotStatus.NotUsed:
      default:
        break;
    }
  }

  isSlotCompatibleForMarking(slot: Slot) {
    return (
      this.isSlotRoomObjectTypeMatchingAndNotLinked(slot) &&
      slot.status != SlotStatus.MarkedForLinking
    );
  }

  doNoCommand(data: WorkflowCallbackData, device: DeviceDTO, slot: Slot) {
    if (data._isSingleLoadFlow && slot != null) {
      if (device != null) {
        device.isDoubleDimmer = false;

        if (this.roomObject.devices) {
          for (var _device of this.roomObject.devices) {
            if (_device.slots) {
              for (var _slotList of _device.slots) {
                if (
                  _slotList.assignedComponentType == ComponentType.Actuator ||
                  _slotList.assignedComponentType ==
                    ComponentType.BlindActuator ||
                  _slotList.assignedComponentType ==
                    ComponentType.ShutterActuator ||
                  _slotList.assignedComponentType ==
                    ComponentType.DimmerActuator
                ) {
                  if (_slotList != slot) {
                    this.markOrUnmarkSlot(
                      this.roomObject,
                      _slotList,
                      _device,
                      SlotStatus.MarkedForLinking,
                      SlotStatus.NotConfigured
                    );
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
